import {Icon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "10",
  height: "5",
  viewBox: "0 0 10 5",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M5.354 4.646L9.146.854A.5.5 0 0 0 8.793 0H1.207a.5.5 0 0 0-.353.854l3.792 3.792a.5.5 0 0 0 .708 0z",
      fill: "currentColor",
      "fill-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render() { return h(Icon, {icon: {render}, name: "icon-caret-down-rounded"}) } }